
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    inheritAttrs: false,
    name: 'ConfirmationDialog',
    components: { DialogTemplate },
})
export default class ConfirmationDialog extends Vue {
    @Prop({ required: true }) props!: any
}
